<template>
  <div class="p-4">
    <h2>{{ group.cn }}</h2>
    <p>{{ group.description }}</p>
    <hr />
    <div class="d-flex justify-content-between mb-3 align-middle">
      <h4>Membre</h4>
      <b-button v-b-modal.modal-1 variant="primary"
        >Ajouter un utilisateur</b-button
      >
    </div>
    <table class="table table-striped mt-2">
      <thead>
        <tr>
          <th>Nom et Prénom</th>
          <th>Uid</th>
          <th>Mail</th>
          <th>Description</th>
          <th>Téléphone</th>
          <th>#</th>
          <th>#</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="member in members" v-bind:key="member">
          <td>{{ member.cn }}</td>
          <td>{{ member.uid }}</td>
          <td>{{ member.mail }}</td>
          <td>{{ member.description }}</td>
          <td>{{ member.telephoneNumber }}</td>
          <td>
            <a
              class="btn btn-light"
              v-bind:href="`/user/` + member.uid + `/details`"
              >Voir</a
            >
          </td>
          <td>
            <button v-on:click="deleteUser(member.uid)" class="btn btn-danger">
              Supprimer
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <hr />
    <button class="btn btn-danger" v-on:click="deleteGroup">Supprimer</button>

    <b-modal
      ref="my-modal"
      id="modal-1"
      hide-footer
      title="Ajouter un utilisateur"
    >
      <form method="POST" @submit="sendForm">
        <div class="form-group">
          <label for="inputPassword4">Utilisateur :</label>
          <br />
          <el-select
            class="w-100"
            v-model="user"
            filterable
            default-first-option
            placeholder="Selectionner un membre"
          >
            <el-option
              v-for="user in users"
              :key="user"
              :label="user.cn"
              :value="user.uid"
            >
            </el-option>
          </el-select>
        </div>
        <button type="submit" class="btn btn-primary">Ajouter</button>
      </form>
    </b-modal>
  </div>
</template>
<script>
import conf from "../../../../config/api.js";

export default {
  data() {
    return {
      conf: conf,
      cn: "",
      group: [],
      members: [],
      users: [],
    };
  },
  beforeMount() {
    this.cn = this.$route.params.cn;
    //console.log(this.$route.params.cn)
    this.axios
      .get(`${conf.server}/api/ldap/group/` + this.cn) // On récupère les infos du groupe en fonction de son cn
      .then((result) => {
        this.group = result.data.data[0]; // On met les infos dans la variable group
        //console.log(this.user)
        this.getUser(this.cn); // On récupère les membres du groupe
      })
      .catch((err) => {
        console.log(err);
      });

    this.axios
      .get(`${conf.server}/api/ldap/user/all`) // On récupère tous les utilisateurs
      .then((result) => {
        this.users = result.data.data; // On met les infos dans la variable users
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    deleteGroup: function(event) { // Fonction pour supprimer un groupe
      event.preventDefault();
      if (confirm("Êtes-vous sur de vouloir supprimer ce rôle ?")) { // On vérifie que l'utilisateur est bien sur
        this.axios
          .delete(`${conf.server}/api/ldap/group/` + this.cn + `/delete`) // On fait une requete pour supprimer le groupe
          .then((result) => {
            window.location.href = `${conf.server}/roles`; // On redirige l'utilisateur vers la page des rôles
          })
          .catch((err) => {
            alert(err.response.data.message); // On affiche le message d'erreur
          });
      }
    },
    hideModal() { // Fonction pour cacher la modal
      this.$refs["my-modal"].hide();
    },
    getUser: function() { // Fonction pour récupérer les membres d'un groupe
      this.axios
        .get(`${conf.server}/api/ldap/group/` + this.cn + `/users`) // On fait une requete pour récupérer les membres du groupe en fonction de son cn
        .then((result) => {
          this.members = result.data.data; // On met les membres dans la variable members
          console.log(result);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteUser: function(id) { // Fonction pour supprimer un utilisateur du groupe en fonction de son uid
      console.log(id);
      if (
        confirm(
          "Êtes-vous sur de vouloir supprimer le rôle " +
            this.cn +
            " à cet utilisateur ?"
        )
      ) { // On vérifie que l'utilisateur est bien sur
        this.axios
          .post(`${conf.server}/api/ldap/group/` + this.cn + `/removeUser`, { // On fait une requete pour supprimer l'utilisateur du groupe
            uid: id,
          })
          .then((result) => {
            this.getUser(this.cn); // On récupère les membres du groupe
          })
          .catch((err) => {
            alert(err.response.data.message); // On affiche le message d'erreur
            console.log(err);
          });
      }
    },
    sendForm: function(event) { // Fonction pour ajouter un utilisateur au groupe
      event.preventDefault(); // On empêche le formulaire d'être envoyé

      this.axios
        .post(`${conf.server}/api/ldap/group/` + this.cn + `/addUser`, { // On fait une requete pour ajouter l'utilisateur au groupe
          uid: this.user,
        })
        .then((result) => {
          this.hideModal(); // On cache la modal
          this.getUser(); // On récupère les membres du groupe
        })
        .catch((err) => {
          this.hideModal(); // On cache la modal
          alert(err.response.data.message); // On affiche le message d'erreur
          console.log(err);
        });
    },
  },
};
</script>
